import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 1000;
  background: white;
  opacity: 1;
  transition-property: opacity;
  transition-duration: 0.5s;
  transition-delay: 0.5s;

  svg {
    opacity: 1;
    transition-property: opacity;
    transition-duration: 0.5s;
  }

  &.fading {
    opacity: 0;

    svg {
      opacity: 0;
    }
  }

  &.done {
    display: none;
  }
`;
